type Props = {
  value: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
};

/** Comma-separated tag editor for document library metadata (not in PDF). */
export function DocumentTagsField({ value, onChange, disabled }: Props) {
  const inputValue = value.join(", ");

  function handleChange(raw: string) {
    const tags = raw
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean)
      .slice(0, 32);
    onChange(tags);
  }

  return (
    <label className="block text-sm sm:col-span-2">
      <span className="font-medium text-gray-700 dark:text-zinc-300">Tags</span>
      <input
        type="text"
        value={inputValue}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        placeholder="policy, hr, onboarding"
        className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-sm disabled:opacity-60 dark:border-zinc-600 dark:bg-zinc-900"
      />
      <p className="mt-1 text-xs text-gray-500 dark:text-zinc-400">
        Comma-separated labels for library browse — not included in exported PDFs.
      </p>
    </label>
  );
}
